module.exports = __webpack_public_path__ + "static/cortex-about-maila-1-min-caafe6620b868f9efba6a830ed09832c.png";